jQuery(function($){

	let onclickParent = '.block-editor, .sc-field-editor';

	$(onclickParent).on('change', 'input, select, textarea, .field.array', function(){
		setTimeout(function(){
			executeFieldConditionalRules();
		}, 10);
	});

	$(onclickParent).on('click', '.typeahead .add-new .select-popup-button, .typeahead .add-new .new-fields-bg', function(){
		setTimeout(function(){
			executeFieldConditionalRules();
		}, 10);
	});

	setTimeout(function(){
		executeFieldConditionalRules();
	}, 1000);

	function executeFieldConditionalRules() {
		console.log('executed');
		let form = $(onclickParent);

		form.find('.field, .scfe-tab').each(function(){
			let conditionalEl = $(this);
			if(hasAttr(conditionalEl, 'conditional_rules')) {
				// console.log($(this));
				let rules = JSON.parse(atob($(this).attr('conditional_rules')));
				$.each(rules, function(conditionalType, conditionalRules) {
					let execute = false;
					$.each(conditionalRules, function(index, rule) {
						if(!isNaN(parseInt(index))) {
							if(evaluateConditionalRule(rule, conditionalEl)) execute = true;
						}
					});
					executeConditionalRule(conditionalEl, conditionalType, execute, conditionalRules);
				});
			} else if(conditionalEl.hasClass('typeahead')) {
				// console.log($(this));
				if(conditionalEl.find('.selected').html() != '') {
					setRequired(conditionalEl, false, true);
				}
			} else {
				setRequired(conditionalEl, true)
			}
		});
	}

	function evaluateConditionalRule(rule, el) {
		let fieldValue;
		if(el.closest('.array-field-group').length && !(rule.hasOwnProperty('type') && rule.type == 'global')) {
			fieldValue = el.closest('.array-field-group').find('[field_name="' + rule.key + '"] [name]').val();
		} else if($('[name="sc-fields[' + rule.key + ']"]').attr('type') == 'checkbox') {
			fieldValue = $('[name="sc-fields[' + rule.key + ']"]').prop('checked');
		} else {
			fieldValue = $('[name="sc-fields[' + rule.key + ']"]').val();
		}

		if(rule.value == 'has_value') {
			if(fieldValue) return true;
		} else if(rule.value == 'has_no_value') {
			if(!fieldValue) return true;
		} else {
			if(fieldValue == rule.value) return true;
		}

		return false;
	}

	function executeConditionalRule(el, conditionalType, execute, conditionalRules) {
		if(conditionalType == 'hide') {
			console.log(conditionalRules);
			if(execute) {
				if(conditionalRules[0].hasOwnProperty('important') && conditionalRules[0].important) {
					console.log('true');
					el.addClass('conditional-hide-important');
				} else {
					el.hide();
				}
				setRequired(el, false);
			} else {
				el.show().removeClass('conditional-hide-important');
				setRequired(el, true);
			}
		} else if(conditionalType == 'show') {
			if(execute) {
				el.show();
				setRequired(el, true);
			} else {
				el.hide();
				setRequired(el, false);
			}
		} else if(conditionalType == 'set_required') {
			if(execute) {
				setRequired(el, true);
			} else {
				setRequired(el, false);
			}
		} else if(conditionalType == 'remove_required') {
			if(execute) {
				setRequired(el, false);
			} else {
				setRequired(el, true);
			}
		} else if(conditionalType == 'label') {
			if(execute) {
				el.find('.labels label').html(conditionalRules.update);
			} else {
				let label = atob(el.attr('field_label'));
				el.find('.labels label').html(label.replace(/("|')/g, ''));
			}
		} else if(conditionalType == 'alt_array_title') {
			console.log(el);
			const array = el.closest('.field.array .array-fields');

			console.log(execute);

			if(execute) {
				array.find('input[alt_array_title]').attr('alt_array_title', 'false').attr('was_array_title', 'true');
				el.find('input[name]').attr('alt_array_title', 'true').attr('not_original_array_title', 'true');
			} else {
				array.find('.field input[was_array_title="true"]').attr('alt_array_title', 'true');
				el.find('input[not_original_array_title=true]').attr('alt_array_title', 'false');
			}

			let arrayLabel = getArrayFieldGroupLabel(array.find('input[alt_array_title=true]'));
			if(arrayLabel == '') arrayLabel = '<span style="font-style: italic">(blank)</span>';
			el.closest('.array-field-group').find('> .header > .array-preview > .preview-field').html(arrayLabel);
		}
	}
});

function getArrayFieldGroupLabel(el) {
	let arrayLabel = el.val();

	if(arrayLabel === undefined) {
		arrayLabel = '';
	} else {
		arrayLabel = arrayLabel.stripSlashes();

		console.log(el);
		console.log(arrayLabel);
		// console.log(atob(arrayLabel));

		//Upload
		if(el.closest('.upload-field').length) arrayLabel = el.closest('.upload-field').attr('filename');

		//Typeahead
		if(el.closest('.field').hasClass('typeahead') && arrayLabel.length) {
			let postId = JSON.parse(arrayLabel)[0];
			console.log(postId);
			if(postId !== undefined) {
				let results = el.closest('.field').find('.input-wrapper .results').attr('results');
				results = JSON.parse(atob(results));

				for(var i = 0; i < results.length; i++) {
					if(postId == results[i].post_id) arrayLabel = results[i].title;
				}
			} else {
				arrayLabel = '';
			}
		}
		
		//Datepicker
		if(el.closest('.field').hasClass('datepicker')) {
			arrayLabel = new Date(arrayLabel + 'T00:00:00').toLocaleDateString('en-us', {
				weekday:"short",
				year:"numeric",
				month:"short",
				day:"numeric",
				timezone:"UTC"
			}) 
		}

		//Select
		if(el.closest('.field').hasClass('select')) {
			let label = '';
			const selectValue = el.val().stripSlashes();
			el.find('option').each(function(){
				if(jQuery(this).val() == selectValue) {
					label = !jQuery(this).val().length ? '' : jQuery(this).html();
				}
			});

			arrayLabel = label;
		}
	}

	return arrayLabel;
}

String.prototype.stripSlashes = function(){
	return this.replace(/\\(.)/mg, "$1");
}

function hasAttr(el, attributeName) {
	var attr = el.attr(attributeName);
	return (typeof attr !== 'undefined' && attr !== false);
}

function setRequired(el, value, stillShow = false) {
	el.find('*').each(function(){
		if(hasAttr(jQuery(this), 'has-required')) {
			if(jQuery(this).closest('.add-new-fields').length) {
				// console.log(jQuery(this).closest('.add-new-fields').hasClass('visible'));
				jQuery(this).attr('required', jQuery(this).closest('.add-new-fields').hasClass('visible'));
			} else {
				jQuery(this).attr('required', value);
			}
		} else if(jQuery(this).hasClass('required')) {
			if(!stillShow) {
				if(value == false) jQuery(this).hide(); else jQuery(this).show();
			}
		}
	});
}
